import BaseProxy from './Proxy';

export default class PaymentGenerationProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/paymentgeneration', parameters);
  }

  overview() {
    return this.submit('get', `${this.endpoint}/overview`);
  }

  details(serviceId) {
    return this.submit('get', `${this.endpoint}/details/${serviceId}`);
  }

  auth(item) {
    return this.submit('post', `${this.endpoint}/auth`, item);
  }

  book(item) {
    return this.submit('post', `${this.endpoint}/book`, item);
  }
}
